var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 42,
    viewBox: "0 0 138 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.858 42H5.10993C2.30075 42 0 39.6362 0 36.75V5.25C0 2.36381 2.30075 1.90735e-06 5.10993 1.90735e-06H132.858C135.667 1.90735e-06 137.968 2.36381 137.968 5.25V36.75C137.968 39.6362 135.667 42 132.858 42Z",
    fill: "#2B3450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4592 10.7562C48.4592 11.6329 48.2037 12.3351 47.7004 12.8588C47.1217 13.4796 46.368 13.792 45.4444 13.792C44.5616 13.792 43.8079 13.4744 43.1896 12.8483C42.57 12.2131 42.2609 11.4334 42.2609 10.5002C42.2609 9.56706 42.57 8.78743 43.1896 8.15743C43.8079 7.52612 44.5616 7.2085 45.4444 7.2085C45.8838 7.2085 46.3028 7.30168 46.7027 7.47493C47.1012 7.6495 47.4257 7.88575 47.6608 8.17712L47.1268 8.731C46.7167 8.23356 46.1585 7.98812 45.4444 7.98812C44.8005 7.98812 44.2422 8.21912 43.7683 8.68506C43.2995 9.15231 43.0644 9.75737 43.0644 10.5002C43.0644 11.2431 43.2995 11.8534 43.7683 12.3207C44.2422 12.7814 44.8005 13.0176 45.4444 13.0176C46.1278 13.0176 46.7027 12.7814 47.1562 12.3154C47.4551 12.007 47.625 11.5817 47.6697 11.0384H45.4444V10.2797H48.4132C48.449 10.4438 48.4592 10.6026 48.4592 10.7562Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1702 8.12584H50.3815V10.1208H52.8955V10.8795H50.3815V12.8745H53.1702V13.6475H49.592V7.35278H53.1702V8.12584Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4945 13.6475H55.7051V8.12584H53.9945V7.35278H58.2064V8.12584H56.4945V13.6475Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2542 13.6475V7.35278H62.0424V13.6475H61.2542Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5366 13.6475H64.7536V8.12584H63.0366V7.35278H67.2536V8.12584H65.5366V13.6475Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2271 12.8378C74.6228 13.4744 73.8742 13.792 72.9813 13.792C72.0832 13.792 71.3346 13.4744 70.7303 12.8378C70.1274 12.2026 69.8271 11.4229 69.8271 10.5002C69.8271 9.57756 70.1274 8.79793 70.7303 8.16268C71.3346 7.52612 72.0832 7.2085 72.9813 7.2085C73.8691 7.2085 74.6177 7.52612 75.222 8.16793C75.8301 8.80843 76.1303 9.58281 76.1303 10.5002C76.1303 11.4229 75.83 12.2026 75.2271 12.8378ZM71.3141 12.3102C71.7689 12.7814 72.3221 13.0176 72.9813 13.0176C73.6353 13.0176 74.1936 12.7814 74.6433 12.3102C75.0968 11.839 75.3267 11.2339 75.3267 10.5002C75.3267 9.76656 75.0968 9.1615 74.6433 8.69031C74.1936 8.21912 73.6353 7.98287 72.9813 7.98287C72.3221 7.98287 71.7689 8.21912 71.3141 8.69031C70.8606 9.1615 70.6307 9.76656 70.6307 10.5002C70.6307 11.2339 70.8606 11.839 71.3141 12.3102Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2378 13.6475V7.35278H78.1959L81.175 12.2484H81.2095L81.175 11.0383V7.35278H81.9632V13.6475H81.1405L78.0209 8.51041H77.9864L78.0209 9.72578V13.6475H77.2378Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6334 22.8401C67.233 22.8401 65.2721 24.717 65.2721 27.3066C65.2721 29.8751 67.233 31.7717 69.6334 31.7717C72.0389 31.7717 73.9998 29.8751 73.9998 27.3066C73.9998 24.717 72.0389 22.8401 69.6334 22.8401ZM69.6334 30.0129C68.3163 30.0129 67.1832 28.896 67.1832 27.3066C67.1832 25.6961 68.3163 24.5989 69.6334 24.5989C70.9505 24.5989 72.0887 25.6961 72.0887 27.3066C72.0887 28.896 70.9505 30.0129 69.6334 30.0129ZM60.1174 22.8401C57.7119 22.8401 55.7561 24.717 55.7561 27.3066C55.7561 29.8751 57.7119 31.7717 60.1174 31.7717C62.5217 31.7717 64.4788 29.8751 64.4788 27.3066C64.4788 24.717 62.5217 22.8401 60.1174 22.8401ZM60.1174 30.0129C58.7991 30.0129 57.6621 28.896 57.6621 27.3066C57.6621 25.6961 58.7991 24.5989 60.1174 24.5989C61.4345 24.5989 62.5676 25.6961 62.5676 27.3066C62.5676 28.896 61.4345 30.0129 60.1174 30.0129ZM48.7938 24.2091V26.1069H53.205C53.0759 27.1674 52.731 27.9471 52.2022 28.4904C51.5583 29.1467 50.5555 29.8751 48.7938 29.8751C46.0792 29.8751 43.9534 27.6242 43.9534 24.8351C43.9534 22.0461 46.0792 19.7951 48.7938 19.7951C50.2617 19.7951 51.3296 20.3844 52.1178 21.1483L53.4196 19.8109C52.3171 18.7294 50.8506 17.8986 48.7938 17.8986C45.0712 17.8986 41.9427 21.0105 41.9427 24.8351C41.9427 28.6598 45.0712 31.7717 48.7938 31.7717C50.8059 31.7717 52.3171 31.0944 53.5052 29.8239C54.7226 28.5731 55.102 26.8144 55.102 25.3942C55.102 24.9532 55.0663 24.5477 55.0024 24.2091H48.7938ZM95.0975 25.6804C94.7385 24.6816 93.6309 22.8401 91.3749 22.8401C89.1393 22.8401 87.278 24.6501 87.278 27.3066C87.278 29.8082 89.1201 31.7717 91.5895 31.7717C93.5862 31.7717 94.7385 30.5209 95.2124 29.7924L93.7306 28.7779C93.2362 29.5207 92.5629 30.0129 91.5895 30.0129C90.6224 30.0129 89.9288 29.5575 89.4842 28.6597L95.298 26.1883L95.0975 25.6804ZM89.17 27.1674C89.1201 25.4454 90.4717 24.5634 91.44 24.5634C92.1989 24.5634 92.8427 24.9533 93.0573 25.5111L89.17 27.1674ZM84.4445 31.5H86.3557V18.375H84.4445V31.5ZM81.3147 23.835H81.2508C80.8216 23.3126 80.0027 22.8401 78.9654 22.8401C76.7886 22.8401 74.7983 24.8036 74.7983 27.321C74.7983 29.8239 76.7886 31.7717 78.9654 31.7717C80.0027 31.7717 80.8216 31.2952 81.2508 30.7571H81.3147V31.3976C81.3147 33.1052 80.4269 34.0226 78.9948 34.0226C77.8272 34.0226 77.1029 33.1564 76.8039 32.4279L75.1419 33.1406C75.621 34.3245 76.8895 35.7814 78.9948 35.7814C81.2355 35.7814 83.1262 34.4269 83.1262 31.1312V23.1118H81.3147V23.835ZM79.1289 30.0129C77.8119 30.0129 76.7094 28.8802 76.7094 27.321C76.7094 25.7473 77.8119 24.5989 79.1289 24.5989C80.4269 24.5989 81.4501 25.7473 81.4501 27.321C81.4501 28.8802 80.4269 30.0129 79.1289 30.0129ZM104.045 18.375H99.4741V31.5H101.38V26.5269H104.045C106.162 26.5269 108.238 24.9532 108.238 22.4503C108.238 19.9487 106.157 18.375 104.045 18.375ZM104.095 24.7013H101.38V20.2007H104.095C105.518 20.2007 106.33 21.4148 106.33 22.4503C106.33 23.4662 105.518 24.7013 104.095 24.7013ZM115.877 22.8152C114.5 22.8152 113.068 23.4399 112.479 24.8246L114.17 25.5531C114.534 24.8246 115.204 24.5884 115.912 24.5884C116.9 24.5884 117.903 25.1987 117.918 26.2763V26.4141C117.574 26.2093 116.835 25.9061 115.927 25.9061C114.105 25.9061 112.249 26.9364 112.249 28.8592C112.249 30.618 113.741 31.7507 115.418 31.7507C116.701 31.7507 117.409 31.1561 117.853 30.4644H117.918V31.479H119.759V26.4443C119.759 24.1172 118.068 22.8152 115.877 22.8152ZM115.647 30.0077C115.024 30.0077 114.155 29.6901 114.155 28.896C114.155 27.8801 115.238 27.4903 116.176 27.4903C117.015 27.4903 117.409 27.6806 117.918 27.9313C117.769 29.1467 116.751 30.0077 115.647 30.0077ZM126.466 23.1026L124.275 28.7923H124.21L121.945 23.1026H119.89L123.293 31.0537L121.351 35.4782H123.343L128.587 23.1026H126.466ZM109.285 31.5H111.196V18.375H109.285V31.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6637 7.91577C10.3635 8.23865 10.1898 8.74133 10.1898 9.39233V32.6131C10.1898 33.2641 10.3635 33.7668 10.6637 34.0896L10.7378 34.1605L23.4028 21.1536V20.8465L10.7378 7.83965L10.6637 7.91577Z",
    fill: "url(#paint0_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.621 25.4912L23.404 21.1534V20.8463L27.6261 16.5085L27.7206 16.5649L32.7207 19.4878C34.1476 20.3173 34.1476 21.6823 32.7207 22.5171L27.7206 25.4348L27.621 25.4912Z",
    fill: "url(#paint1_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7195 25.4352L23.4029 21.0003L10.6638 34.0898C11.1378 34.6017 11.9106 34.6634 12.7895 34.1515L27.7195 25.4352Z",
    fill: "url(#paint2_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7195 16.5651L12.7895 7.84875C11.9106 7.34213 11.1378 7.40381 10.6638 7.91569L23.4029 21L27.7195 16.5651Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 22.2783,
    y1: 32.8549,
    x2: 4.66319,
    y2: 15.7098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 34.5788,
    y1: 20.9984,
    x2: 9.84989,
    y2: 20.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.3722,
    y1: 18.5894,
    x2: 1.48477,
    y2: -4.6608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.45713,
    y1: 41.815,
    x2: 18.124,
    y2: 31.4328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.918e8aff.svg";
export { ForwardRef as ReactComponent };